import React from 'react';
import { CheckIcon, RocketIcon, EyeIcon } from 'lucide-react';
import { railProjects, railTasks } from '../data/demandBriefing';
const kindIcon = {
  approval: CheckIcon,
  launch: RocketIcon,
  review: EyeIcon
};
export function DemandWorkRail({
  onViewProjects
}: {
  onViewProjects: () => void;
}) {
  return <aside aria-label="Today's work" className="space-y-5" data-id="element-1080" data-mp="h88hjm5p7opq">
      <section className="rounded-2xl border border-ink/10 bg-paper p-5 shadow-sm" data-id="element-1081" data-mp="3pn0awy5qon8p">
        <h3 className="text-[11px] font-semibold uppercase tracking-wider text-ink/45" data-id="element-1082" data-mp="3pkw5gbs6zg6b">Today</h3>
        <ul className="mt-3 space-y-2.5" data-id="element-1083" data-mp="3klt4b2fc1u3m">
          {railTasks.map(task => {
          const Icon = kindIcon[task.kind];
          return <li key={task.id} data-id="element-1084" data-mp="3toc0j3om58gw">
                <button type="button" className="flex w-full items-start gap-3 rounded-xl border border-ink/10 px-3.5 py-3 text-left transition-colors hover:border-[#BB5E40]/45 hover:bg-[#BB5E40]/[0.04]" data-id="element-1085" data-mp="3tnaqn2jc2s0r">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#BB5E40]/10 text-[#BB5E40]" data-id="element-1086" data-mp="284eqj3obq8xp">
                    <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1087" data-mp="2d0wrrtkg3p5a" />
                  </span>
                  <span className="min-w-0" data-id="element-1088" data-mp="2hty6a0gqpmoc">
                    <span className="block text-sm font-semibold leading-snug" data-id="element-1089" data-mp="2ms9i2gqli797">{task.title}</span>
                    <span className="mt-0.5 block text-xs text-ink/50" data-id="element-1090" data-mp="1p50soanh4e1x">
                      {task.owner} · {task.due}
                    </span>
                  </span>
                </button>
              </li>;
        })}
        </ul>
      </section>

      <section className="rounded-2xl border border-ink/10 bg-paper p-5 shadow-sm" data-id="element-1091" data-mp="1z51ec38tf69a">
        <div className="flex items-center justify-between" data-id="element-1092" data-mp="243mey3rzbry9">
          <h3 className="text-[11px] font-semibold uppercase tracking-wider text-ink/45" data-id="element-1093" data-mp="3ain4nrqevdwe">Projects</h3>
          <button type="button" onClick={onViewProjects} className="text-xs font-semibold text-[#94452E] hover:underline" data-id="element-1094" data-mp="3fgf55a54g8c7">
            View all
          </button>
        </div>
        <ul className="mt-3 space-y-3.5" data-id="element-1095" data-mp="1afuh0zkuz958">
          {railProjects.map(project => <li key={project.id} data-id="element-1096" data-mp="1ai8aj3zw4dao">
              <div className="flex items-baseline justify-between gap-3" data-id="element-1097" data-mp="1ofwy4jlcdyjf">
                <span className="truncate text-sm font-semibold" data-id="element-1098" data-mp="1ke1w1cvl7h4l">{project.name}</span>
                <span className="shrink-0 text-sm font-semibold tabular-nums text-ink/70" data-id="element-1099" data-mp="1kc7em8jiy759">{project.progress}%</span>
              </div>
              <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-ink/8" data-id="element-1100" data-mp="rq5t3qffcszd">
                <div className="h-full rounded-full bg-[#BB5E40]" style={{
              width: `${project.progress}%`
            }} data-id="element-1101" data-mp="15haxf5tqm9g1" />
              </div>
              <p className="mt-1.5 text-xs text-ink/50" data-id="element-1102" data-mp="10p9cywmf1cex">
                {project.lead} · Next: {project.nextStep}
              </p>
            </li>)}
        </ul>
      </section>
    </aside>;
}